import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/SubscriptionForm.css"; // Import the custom CSS

const SubscriptionForm = () => {
  const { t } = useTranslation();

  return (
    <div id="mc_embed_shell">
      <link
        href="//cdn-images.mailchimp.com/embedcode/classic-061523.css"
        rel="stylesheet"
        type="text/css"
      />
      <style type="text/css">
        {`
        #mc_embed_signup {
          background: #fff;
          clear: left;
          font: 14px Helvetica, Arial, sans-serif;
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
        }
        `}
      </style>
      <div id="mc_embed_signup">
        <form
          action="https://app.us17.list-manage.com/subscribe/post?u=ba45e76c29f11e9f259e5a7c3&amp;id=b9b0da1060&amp;f_id=00f08ae0f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
          noValidate
        >
          <div id="mc_embed_signup_scroll">
            <h2>{t("subscriptionForm.heading")}</h2>
            <div className="indicates-required">
              <span className="asterisk">*</span>{" "}
              {t("subscriptionForm.requiredField")}
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-EMAIL">
                {t("subscriptionForm.emailLabel")}{" "}
                <span className="asterisk">*</span>
              </label>
              <input
                type="email"
                name="EMAIL"
                className="required email"
                id="mce-EMAIL"
                required
              />
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-FNAME">
                {t("subscriptionForm.firstNameLabel")}
              </label>
              <input type="text" name="FNAME" className="text" id="mce-FNAME" />
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-LNAME">
                {t("subscriptionForm.lastNameLabel")}
              </label>
              <input type="text" name="LNAME" className="text" id="mce-LNAME" />
            </div>
            <div id="mce-responses" className="clear foot">
              <div
                className="response"
                id="mce-error-response"
                style={{ display: "none" }}
              ></div>
              <div
                className="response"
                id="mce-success-response"
                style={{ display: "none" }}
              ></div>
            </div>
            <div
              aria-hidden="true"
              style={{ position: "absolute", left: "-5000px" }}
            >
              <input
                type="text"
                name="b_ba45e76c29f11e9f259e5a7c3_b9b0da1060"
                tabIndex="-1"
                value=""
              />
            </div>
            <div className="optionalParent">
              <div className="clear foot">
                <input
                  type="submit"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  className="button"
                  value={t("subscriptionForm.subscribeButton")}
                />
                <p style={{ margin: "0px auto" }}>
                  <a
                    href="http://eepurl.com/iXBGR6"
                    title="Mailchimp - email marketing made easy and fun"
                  >
                    <span
                      style={{
                        display: "inline-block",
                        backgroundColor: "transparent",
                        borderRadius: "4px",
                      }}
                    >
                      <img
                        className="refferal_badge"
                        src="https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/images/intuit-mc-rewards-text-dark.svg"
                        alt="Intuit Mailchimp"
                        style={{
                          width: "220px",
                          height: "40px",
                          display: "flex",
                          padding: "2px 0px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      />
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
      <script
        type="text/javascript"
        src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
      ></script>
      <script type="text/javascript">{`
          (function($) {
              window.fnames = new Array(); 
              window.ftypes = new Array();
              fnames[0] = 'EMAIL';
              ftypes[0] = 'email';
              fnames[1] = 'FNAME';
              ftypes[1] = 'text';
              fnames[2] = 'LNAME';
              ftypes[2] = 'text';
              fnames[3] = 'ADDRESS';
              ftypes[3] = 'address';
              fnames[4] = 'PHONE';
              ftypes[4] = 'phone';
              fnames[5] = 'BIRTHDAY';
              ftypes[5] = 'birthday';
          })(jQuery);
          var $mcj = jQuery.noConflict(true);
      `}</script>
    </div>
  );
};

export default SubscriptionForm;
